import styled from "styled-components"

const PLACEHOLDER_IMG =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><rect width="100" height="100" fill="#eee"/><text x="50" y="50" text-anchor="middle" dy=".3em" fill="#999" font-size="12">No image</text></svg>'
  )

const ContainerFluid = styled.div`
  width: 100%;
`

const Item = styled.div`
  img {
    width: 100%;
    max-height: 100px;
  }

  span {
    font-weight: normal;
    color: #aaa;
    font-size: 0.9rem;
    padding-left: 1em;
    display: block;
  }
`

type ProductListItemProps = {
  rank: number
  productImage?: string
  productName: string
  productSKU?: string
  claimsMade: number
}

const ProductListItem = (props: ProductListItemProps) => {
  return (
    <ContainerFluid className="px-0">
      <Item>
        <div className="row">
          <div className="col-3">
            <img
              src={props.productImage || PLACEHOLDER_IMG}
              alt={props.productName}
            />
          </div>
          <div className="col-6">
            {props.productName}
            <span>{props.productSKU}</span>
          </div>
          <div className="col-3 text-end fw-bold">{props.claimsMade}</div>
        </div>
      </Item>
    </ContainerFluid>
  )
}

export default ProductListItem
